// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + (chunkId === 443 ? "about" : chunkId) + "-legacy." + {"101":"97061e96","213":"8bc59e80","443":"c9b6fc4e","460":"7b6393fb","505":"c9d1c08f","591":"be341ee4","617":"02049f04","744":"9d0e2cdc","870":"3ebc4bef","902":"f5d9c781","947":"a2247e88"}[chunkId] + ".js";
};